import { gql } from "@apollo/client";import { useLazyQuery } from "@apollo/client/react";
import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import ListItemIcon from '@mui/material/ListItemIcon';
import KeyIcon from '@mui/icons-material/Key';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Logout from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from '@mui/material';
import { Chip } from '@mui/material';
import { Avatar } from "@mui/material";
import '../../../../assets/css/App.css';
import { useNavigate } from 'react-router';
import Cookies from 'universal-cookie';
import i18next from '../../../../language/i18next';
import Logo from '../../../../assets/images/conhecta_logo.svg';

import moment from "moment";
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { DesktopOrTabletContainer, MobileContainer } from '../../../../responsiveTools/ResponsiveContainers';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useLogout } from "../../../../components/hooks/useLogout";


export default function ProfileSection() {

  const cookies = new Cookies();

  const userName = sessionStorage.getItem('apellido') ? sessionStorage.getItem('nombre') + ' ' + sessionStorage.getItem('apellido') : "";

  const imagenPerfilDecode = sessionStorage.getItem('imagenPerfilDecode');
  const imagenPerfilTipo = sessionStorage.getItem('imagenPerfilTipo');

  const imagenURL = sessionStorage.getItem('imagenPerfil');
  // armo la imagen que viene de la base de datos
  const imagenLoad = "data:" + imagenPerfilTipo + ";base64, " + imagenPerfilDecode;

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openDlgAboutUs, setOpenDlgAboutUs] = React.useState(false);
  const [ultimaVersion, setUltimaVersion] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = useLogout();

  const handleLogout = async () => {
    await logout();
    sessionStorage.clear();
    cookies.remove("accessToken");
    cookies.remove("idUsuario");
    cookies.remove("auditoria_filter_accion");
    cookies.remove("auditoria_filter_fechaDesde");
    cookies.remove("auditoria_filter_fechaHasta");
    window.location.replace('/');
  };

  const handleContraseña = () => {
    navigate('/cambiarPassword');
  };

  const handleTerminos = () => {
    navigate('/terminos');
  };

  const handleNotificaciones = () => {
    navigate('/notificaciones');
  };

  const handlePreferencias = () => {
    navigate('/preferencias');
  };

  const handleConfigUser = () => {
    navigate('/configuser');
  };

  const handleAcercaDeNosotros = () => {
    setOpenDlgAboutUs(true);
  };

  // consulto la última versión
  React.useEffect(() => {
    getUltimaVersion();
  }, []);

  const QGetUltimaVersion = gql`
  query QGetUltimaVersion {
      ultimaVersion
      {
          success,
          error,
          valorEsperado {
              id,
              version,
              fecha,
              texto
          }
      }
  }`;

  const [getUltimaVersion, { data: dataUltimaVersion }] = useLazyQuery(QGetUltimaVersion, {
    fetchPolicy: 'cache-and-network'
  });

  React.useEffect(() => {
    if (!dataUltimaVersion) return;
    if (dataUltimaVersion.ultimaVersion.success) {
      setUltimaVersion(dataUltimaVersion.ultimaVersion.valorEsperado);
    };
  }, [dataUltimaVersion]);  

  return (
    <React.Fragment>
      <DesktopOrTabletContainer>
        <Box sx={{ alignItems: 'center', textAlign: 'center' }}>
          <Chip
            avatar={
            <Avatar
              className='avatar-icon'
              src={imagenURL ? imagenURL : imagenLoad} />

            }
            color="primary"
            label={userName}
            variant='outlined'
            onClick={handleClick} />
          
        </Box>
      </DesktopOrTabletContainer>

      <MobileContainer>
        <IconButton onClick={handleClick}>
          <PersonOutlineOutlinedIcon />
        </IconButton>
      </MobileContainer>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        
        <MenuItem style={{ fontSize: 13 }} onClick={handleContraseña}>
          <ListItemIcon>
            <KeyIcon style={{ fontSize: 20 }} />
          </ListItemIcon>
          {i18next.t("cambiarContrasena")}
        </MenuItem>
        <MenuItem style={{ fontSize: 13 }} onClick={handlePreferencias}>
          <ListItemIcon>
            <SettingsIcon style={{ fontSize: 20 }} />
          </ListItemIcon>
          {i18next.t("preferencias")}
        </MenuItem>
        <MenuItem style={{ fontSize: 13 }} onClick={handleConfigUser}>
          <ListItemIcon>
            <PersonIcon style={{ fontSize: 20 }} />
          </ListItemIcon>
          {i18next.t("configuracionUsuario")}
        </MenuItem>
        <MenuItem style={{ fontSize: 13 }} onClick={handleTerminos}>
          <ListItemIcon>
            <PlaylistAddCheckIcon style={{ fontSize: 20 }} />
          </ListItemIcon>
          {i18next.t("terminos")}
        </MenuItem>
        <MenuItem style={{ fontSize: 13 }} onClick={handleNotificaciones}>
          <ListItemIcon>
            <NotificationsIcon style={{ fontSize: 20 }} />
          </ListItemIcon>
          {i18next.t("configuracionNotificaciones")}
        </MenuItem>
        <MenuItem style={{ fontSize: 13 }} onClick={handleAcercaDeNosotros}>
          <ListItemIcon>
            <InfoIcon style={{ fontSize: 20 }} />
          </ListItemIcon>
          {i18next.t("acercaDeNutrihome")}
        </MenuItem>
        <MenuItem style={{ fontSize: 13 }} onClick={handleLogout}>
          <ListItemIcon>
            <Logout style={{ fontSize: 20 }} />
          </ListItemIcon>
          {i18next.t("cerrarSesion")}
        </MenuItem>
      </Menu>

      <CustomDialog
        maxWidth="md"
        open={openDlgAboutUs}
        onCancel={() => setOpenDlgAboutUs(false)}
        cancelText='Cerrar'>
        
        <img src={Logo} width="130" height="30"></img>
        <br /><br />
        El <strong>Sistema NutriHome</strong> es una aplicación desarrollada por Fresenius Kabi S.A. destinado a la <strong>administración de los recursos</strong> necesarios para brindar los <strong>servicios de cuidado de pacientes</strong> según tratamiento requerido.
        <br /><br />
        <strong>Versión {ultimaVersion && ultimaVersion.version}</strong>
        <br />
        Fecha de implementación en Producción: <strong>{ultimaVersion != null ? moment(ultimaVersion.fecha).format("DD/MM/YYYY") : ""}</strong>
        <br />
        <u>Información respecto de la versión:</u><br />
        {ultimaVersion && ultimaVersion.texto}
      </CustomDialog>
    </React.Fragment>);

}